/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Sending1Inputs */

const zh_organizationsettings_sending1 = /** @type {(inputs: Organizationsettings_Sending1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送中...`)
};

const en_organizationsettings_sending1 = /** @type {(inputs: Organizationsettings_Sending1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const es_organizationsettings_sending1 = /** @type {(inputs: Organizationsettings_Sending1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Organizationsettings_Sending1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_sending1 = /** @type {((inputs?: Organizationsettings_Sending1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Sending1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_sending1(inputs)
	if (locale === "en") return en_organizationsettings_sending1(inputs)
	return es_organizationsettings_sending1(inputs)
});
export { organizationsettings_sending1 as "organizationSettings_sending" }